export interface CompanyOverviewRes {
	header: {
		CompDEIID: string;
		CompLegalName: string;
	};
	overview: CompanyOverview;
}

export interface CompanyOverview {
	availableReportingPeriods: number[];
	newInSilver: string;
	rating: string;
}

// * main page companies base info.
export interface CompanyInfoProperties {
	ageDiversityAbsoluteRating: string;
	ageDiversityRelativeRating: string;
	boardDiversityAbsoluteRating: string;
	boardDiversityRelativeRating: string;
	disabilityCEO: string;
	disabilityDiversityAbsoluteRating: string;
	disabilityDiversityRelativeRating: string;
	disabilityOwnership: string;
	executiveDiversityAbsoluteRating: string;
	executiveDiversityRelativeRating: string;
	genderDiversityAbsoluteRating: string;
	genderDiversityRelativeRating: string;
	lgbtqCEO: string;
	lgbtqOwnership: string;
	overallDiversityAbsoluteRating: string;
	overallDiversityRelativeRating: string;
	raceEthnicityDiversityAbsoluteRating: string;
	raceEthnicityDiversityRelativeRating: string;
	racialMinorityCEO: string;
	racialMinorityOwnership: string;
	sme: string;
	socialImpact: string;
	sociallyDisadvantaged: string;
	veteranCEO: string;
	veteranOwnership: string;
	womanWomenCEO: string;
	womanWomenOwnership: string;
}

export interface CompanyInfo {
	id: number;
	name: string;
	dateOfIssue: string | null;
	expirationDate: string | null;
	properties: CompanyInfoProperties | null;
}

export interface CompanyFullInfo {
	id: number;
	name: string;
	dateOfIssue: string;
	expirationDate: string;
	properties: CompanyInfoProperties;
}

export const isCompanyInfoFull = (companyInfo: CompanyInfo): companyInfo is CompanyFullInfo => {
	return companyInfo.properties !== null && companyInfo.dateOfIssue !== null && companyInfo.expirationDate !== null;
};

export type CompaniesInfoRES = CompanyInfo[];
